export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-es-a56f0e74.png'